// --- Dependencies -------------------------------------------------------------------------------
import { NavLink } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useNavTabs from "@/hooks/useNavTabs";
import usePopup from "@/hooks/usePopup";
import useTranslation from "@/hooks/useTranslation";
import MoreTabsPopup from "@/UI/popups/MoreTabsPopup";
import "./styles.css";

// --- Constants ----------------------------------------------------------------------------------

/** Five thumb targets across a phone is the practical limit — four tabs plus "More". */
const VISIBLE_TABS = 4;

// --- Logic --------------------------------------------------------------------------------------

/**
 * The phone-sized replacement for the sidebar. The sidebar's toggle lives at the top of the screen,
 * which is the hardest place to reach one-handed, so on small screens navigation moves down to where
 * the thumb already rests.
 */
export default function BottomBar() {
    const t = useTranslation();
    const { allTabs } = useNavTabs();
    const { addComp, removeComp } = usePopup();

    const visibleTabs = allTabs.slice(0, VISIBLE_TABS);

    const openMoreTabs = () => {
        const name = "more-tabs";
        removeComp(name);
        addComp({ name, Component: MoreTabsPopup, place: "end", anim: "endSlide", cover: "shaded" });
    };

    return (
        <nav className="bottom-bar">
            {visibleTabs.map((tab) => (
                <NavLink
                    key={tab.path}
                    to={tab.path}
                    end={tab.path === "/"}
                    className={({ isActive }) => `bottom-bar-btn${isActive ? " active" : ""}`}
                >
                    <img
                        className="bottom-bar-btn-icon bottom-bar-btn-icon--dark"
                        src={`/icons/side-bar/${tab.icon}-icon-dark.svg`}
                        alt={tab.label}
                    />
                    <img className="bottom-bar-btn-icon bottom-bar-btn-icon--white" src={`/icons/side-bar/${tab.icon}-icon-white.svg`} alt="" />
                </NavLink>
            ))}

            <button type="button" className="bottom-bar-btn bottom-bar-more" onClick={openMoreTabs} aria-label={t.bottomBar.more}>
                <img className="bottom-bar-btn-icon bottom-bar-more-icon" src="/icons/menu-icon.svg" alt="" />
            </button>
        </nav>
    );
}
